module.exports = __webpack_public_path__ + "img/norway-diabetes-mellitus-female.0f5a99c2.png";